export default __webpack_public_path__ + "static/editorialImg-dd26085f5405b6bcadabacd14af2aa2d.webp";